export const API = "https://gratustech.com/api";
